import { render, staticRenderFns } from "./UserEditPasswordCard.vue?vue&type=template&id=ce7937fc&"
import script from "./UserEditPasswordCard.vue?vue&type=script&lang=js&"
export * from "./UserEditPasswordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports